const STABLE_KEY_ATTR = 'data-ui-key';

const stableIdentity = (element: Element, explicit?: unknown): string | null => {
    if (typeof explicit === 'string' && explicit) return explicit;
    return element.getAttribute(STABLE_KEY_ATTR) || element.id || null;
};

export {STABLE_KEY_ATTR, stableIdentity};
